"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebPlatformAdapter = void 0;
const firestore_1 = require("firebase/firestore");
const auth_1 = require("firebase/auth");
const functions_1 = require("firebase/functions");
const PlatformDetector_1 = require("./PlatformDetector");
/**
 * Web platform adapter for Firebase
 * Handles web-specific configuration and emulator setup
 */
class WebPlatformAdapter {
    detectPlatform() {
        return PlatformDetector_1.PlatformDetector.detect();
    }
    getConfig() {
        if (!PlatformDetector_1.PlatformDetector.isWeb()) {
            throw new Error('WebPlatformAdapter can only be used in web environment');
        }
        const config = {
            apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyAzDO-bf5yFLAFnCWx16DaMSvTfH98HTI4",
            authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "watchlists-1c639.firebaseapp.com",
            projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "watchlists-1c639",
            storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "watchlists-1c639.firebasestorage.app",
            messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "418607615172",
            appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:418607615172:web:10d2509b05a68f7c864d91",
            measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || "G-D8LWR49JVD"
        };
        const useEmulators = process.env.NODE_ENV === 'development' &&
            process.env.REACT_APP_USE_EMULATORS === 'true';
        return {
            config,
            useEmulators,
            emulatorPorts: {
                firestore: 8080,
                auth: 9099,
                functions: 5001
            }
        };
    }
    setupEmulators(services, ports) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            try {
                // Connect Firestore emulator
                if (services.firestore && ports.firestore) {
                    // Check if already connected to avoid errors
                    const firestoreSettings = (_b = (_a = services.firestore._delegate) === null || _a === void 0 ? void 0 : _a._databaseId) === null || _b === void 0 ? void 0 : _b.database;
                    if (!(firestoreSettings === null || firestoreSettings === void 0 ? void 0 : firestoreSettings.includes('emulator'))) {
                        (0, firestore_1.connectFirestoreEmulator)(services.firestore, 'localhost', ports.firestore);
                        console.log('🔥 Connected to Firestore emulator on port', ports.firestore);
                    }
                }
                // Connect Auth emulator  
                if (services.auth && ports.auth) {
                    const authConfig = services.auth.config;
                    if (!(authConfig === null || authConfig === void 0 ? void 0 : authConfig.emulator)) {
                        (0, auth_1.connectAuthEmulator)(services.auth, `http://localhost:${ports.auth}`);
                        console.log('🔑 Connected to Auth emulator on port', ports.auth);
                    }
                }
                // Connect Functions emulator
                if (services.functions && ports.functions) {
                    const functionsUrl = services.functions._url;
                    if (!(functionsUrl === null || functionsUrl === void 0 ? void 0 : functionsUrl.includes('localhost'))) {
                        (0, functions_1.connectFunctionsEmulator)(services.functions, 'localhost', ports.functions);
                        console.log('⚡ Connected to Functions emulator on port', ports.functions);
                    }
                }
            }
            catch (error) {
                console.log('🔥 Emulators already connected or unavailable:', error);
            }
        });
    }
}
exports.WebPlatformAdapter = WebPlatformAdapter;
